import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { IconPin, IconPhone, LogoCarGlass } from './Icons';

const TopBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    if (!isHomePage) {
      setActiveSection('');
      return;
    }

    const sections = ['services', 'why-us', 'reviews'];

    const handleScrollTracking = () => {
      let currentSection = '';
      for (const id of sections) {
        const element = document.getElementById(id);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 200) {
            currentSection = id;
          }
        }
      }
      setActiveSection(currentSection);
    };

    window.addEventListener('scroll', handleScrollTracking, { passive: true });
    handleScrollTracking();

    return () => window.removeEventListener('scroll', handleScrollTracking);
  }, [isHomePage]);

  const handleScroll = (id) => {
    if (!isHomePage) {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const y = el.getBoundingClientRect().top + window.pageYOffset - 85;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100);
      return;
    }

    const element = document.getElementById(id);
    if (element) {
      const yOffset = -85;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <div className="top-bar">
      <div className="top-bar-content">
        
        {/* Логотип со стеклом и контакты */}
        <div className="logo-and-contacts">
          <NavLink to="/" className="main-logo">
            <LogoCarGlass size={32} />
            <span>Автостекло-Сервис</span>
          </NavLink>
          <div className="contact-info">
            <div className="info-item">
              <IconPin size={16} color="#ffffff" />
              <span>г. Бийск</span>
            </div>
            <div className="info-item">
              <IconPhone size={16} color="#ffffff" />
              <a href="tel:+79609474777">+7 (960) 947-47-77</a>
            </div>
          </div>
        </div>

        {/* Навигация */}
        <div className="navigation-and-user">
          <nav className="main-nav">
            <button 
              type="button" 
              className={`nav-text-btn ${activeSection === 'services' ? 'active' : ''}`} 
              onClick={() => handleScroll('services')}
            >
              Услуги
            </button>
            <button 
              type="button" 
              className={`nav-text-btn ${activeSection === 'why-us' ? 'active' : ''}`} 
              onClick={() => handleScroll('why-us')}
            >
              Почему мы
            </button>
            <button 
              type="button" 
              className={`nav-text-btn ${activeSection === 'reviews' ? 'active' : ''}`} 
              onClick={() => handleScroll('reviews')}
            >
              Отзывы
            </button>
          </nav>
          
          <div className="user-actions">
            <NavLink to="/contacts" className="nav-button">Контакты</NavLink>
          </div>
        </div>

      </div>
    </div>
  );
};

export default TopBar;